import { Pipe, LOCALE_ID } from '@angular/core';
import { formatNumber, formatDate } from '@angular/common';

export class FormatData {

  constructor() {

  }

  static formatCurrency(currency:any) {
    if (typeof currency == 'string') {
      currency = currency.replace(/,/g, '')
    }
    let tmpValue = parseFloat(currency);
    let value = (isNaN(tmpValue)) ? 0 : tmpValue;
    return formatNumber(value, 'en-US', '1.2-2');
  }

  static formatFloat(value:any) {
    if (typeof value == 'string') {
      value = value.replace(/,/g, '')
    }
    let tmpValue = parseFloat(value);
    value = (isNaN(tmpValue)) ? 0 : tmpValue;
    return value;
  }

  static formatLogItem(item?: string): string {
    const raw = String(item ?? '').trim();
    if (!raw) {
      return '';
    }
    switch (raw) {
      case 'ORDER FOR RETURN':
        return 'RETURNING';
      case 'FRAME RETURNED':
        return 'AWAITING CREDIT';
      case 'ORDER RETURNED':
        return 'RETURNED';
      case 'FRAME RECEIVED':
        return 'RECEIVED';
      case 'ORDERED FRAME':
        return 'ORDERED';
      case 'JOB CREATED':
        return 'JOB CREATED';
      case 'QUOTE CREATED':
        return 'QUOTE CREATED';
      case 'CONVERTED TO ORDER':
        return 'CONVERTED TO ORDER';
      case 'HOLD':
        return 'HOLD/RX';
      case 'CALL':
        return 'CALL FOR RX';
      case 'ORDER':
        return 'SENT TO TO-DO';
      case 'SHIPPED':
        return 'SHIPPED';
      case 'SENT FOR REPAIR':
        return 'SENT FOR REPAIR';
      case 'REPAIR / ENCLOSED':
        return 'REPAIR / ENCLOSED';
      case 'REPAIR':
        return 'REPAIR';
      case 'DUPLICATE':
        return 'DUPLICATE';
      case 'EXCHANGE':
        return 'EXCHANGE';
      case 'NEW RX':
        return 'NEW RX';
      case 'RE-DO':
        return 'RE-DO';
      case 'RETURN':
        return 'RETURN';
      case 'Invoice emailed to customer':
        return 'Invoice emailed to customer';
      case 'DISPENSED':
        return 'DISPENSED';
      default:
        break;
    }
    if (
      /^DUPLICATE FROM /i.test(raw) ||
      /^REPAIR FROM /i.test(raw) ||
      /^EXCHANGE FROM /i.test(raw) ||
      /^NEW RX FROM /i.test(raw) ||
      /^RE-DO FROM /i.test(raw) ||
      /^RETURN FROM /i.test(raw)
    ) {
      return raw;
    }
    const dirty = raw.match(/^([^:]+):\s*(.*)$/);
    if (dirty) {
      const label = FormatData.dirtyFieldLabel(dirty[1].trim());
      const value = dirty[2];
      if (label) {
        return value ? `${label} ${value}` : label;
      }
    }
    return raw;
  }

  static dirtyFieldLabel(key: string): string {
    switch (key) {
      case 'physicalStatus':
        return 'FRAME STATUS CHANGED TO';
      case 'status':
        return 'JOB STATUS CHANGED TO';
      case 'jobAction':
        return 'JOB ACTION SELECTED';
      case 'todo':
        return 'SENT TO';
      case 'followUpDate':
        return 'FOLLOW-UP DATE SET TO';
      case 'referenceNumber':
        return 'VENDOR REF. #';
      case 'activityStatus':
        return 'ACTIVITY ADDED';
      case 'fulfillment':
        return 'FULFILLMENT SET TO';
      case 'carrier':
        return 'CARRIER SET TO';
      case 'trackingNumber':
        return 'TRACKING #';
      case 'labVendor':
        return 'LAB / VENDOR ENTERED';
      case 'rxStatus':
        return 'RX STATUS SET TO';
      case 'color':
        return 'FRAME COLOR CHANGED TO';
      case 'model':
        return 'FRAME MODEL CHANGED TO';
      case 'size':
        return 'FRAME SIZE CHANGED TO';
      case 'invoiceNumber':
        return 'INVOICE NUMBER ASSIGNED';
      case 'vendor':
        return 'VENDOR/LAB ENTERED';
      case 'frameOnly':
        return 'FRAME ONLY';
      default:
        return '';
    }
  }

  static invoiceFamilyRoot(invoiceNumber?: string): string {
    return String(invoiceNumber || '')
      .trim()
      .replace(/-(RX|FX|RT|V|C|R|X)\d*$/i, '');
  }
}
